import gql from 'graphql-tag';

import {
  CampaignsByUserIdQuery,
  CampaignsByUserIdQueryVariables,
  CreateCampaignMutation,
  CreateCampaignMutationVariables,
  DeleteCampaignMutation,
  DeleteCampaignMutationVariables,
  GetCampaignQuery,
  GetCampaignQueryVariables,
  UpdateCampaignMutation,
  UpdateCampaignMutationVariables,
} from '../../API';
import {
  createCampaign as createCampaignsMutation,
  deleteCampaign as deleteCampaignsMutation,
  updateCampaign as updateCampaignsMutation,
} from '../../graphql/mutations';
import { campaignsByUserId, getCampaign as getCampaignQuery } from '../../graphql/queries';

import { mutation, query } from './api';

const CREATE_CAMPAIGN = gql(createCampaignsMutation);
const UPDATE_CAMPAIGN = gql(updateCampaignsMutation);
const DELETE_CAMPAIGN = gql(deleteCampaignsMutation);
const LIST_CAMPAIGN = gql(campaignsByUserId);
const GET_CAMPAIGN = gql(getCampaignQuery);

export const CAMPAIGNS_FETCH_LIMIT = 100; // default fetch size is 100 but can be used to configure a different size or for testing the behavior of graphql query

export async function listCampaigns(variables?: CampaignsByUserIdQueryVariables) {
  const data = await query<CampaignsByUserIdQueryVariables, CampaignsByUserIdQuery>(LIST_CAMPAIGN, {
    limit: CAMPAIGNS_FETCH_LIMIT,
    ...variables,
  });

  return data.campaignsByUserId;
}

export async function getCampaign(variables?: GetCampaignQueryVariables) {
  const data = await query<GetCampaignQueryVariables, GetCampaignQuery>(GET_CAMPAIGN, variables);

  return data.getCampaign;
}

export async function createCampaign(variables?: CreateCampaignMutationVariables) {
  const data = await mutation<CreateCampaignMutationVariables, CreateCampaignMutation>(CREATE_CAMPAIGN, variables);

  return data?.createCampaign;
}

export async function updateCampaign(variables?: UpdateCampaignMutationVariables) {
  const data = await mutation<UpdateCampaignMutationVariables, UpdateCampaignMutation>(UPDATE_CAMPAIGN, variables);

  return data?.updateCampaign;
}

export async function deleteCampaign(variables?: DeleteCampaignMutationVariables) {
  const data = await mutation<DeleteCampaignMutationVariables, DeleteCampaignMutation>(DELETE_CAMPAIGN, variables);

  return data?.deleteCampaign;
}
